import { FC } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import LoginForm from '../../ui/LoginForm/LoginForm';
import { Props } from '../../../interfaces/interfaces';

const Home: FC<Props> = (props): JSX.Element => {
  return (
    <section className="top">
      <Container fluid="md" style={{ minHeight: '70vh' }}>
        <h1 className="px-3 mb-5 display-5 text-center">{props.header}</h1>
        <p className="px-3 fs-4 text-center fw-light">
          Vítejte na stránkách administrace portálu Změňte.to
        </p>
        <Row className="mb-5">
          <Col xs={12} sm={{ span: '6', offset: '3' }}>
            <div className="d-grid">
              <LoginForm formTitle={'Zadejte své vstupní údaje'} username password fn="login" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Home;
